module.exports = __webpack_public_path__ + "static/cosi8s-b621b8bdcd48e195b11d7230a49c1974.jpg";